import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Collateral, ClearingHouse, ProductSectorAggregate } from 'api'
import { CollateralsPanelGrid } from './CollateralsPanelGrid'
import { CollateralsPanelGridRow } from './CollateralsPanelGridModel'
import { createProductSectorAggregateGetterSelector } from 'selectors/fatFingerSelectors'
import { ProductSectorAggregateHelper } from 'model'
import { rebuildEnabledIds, GridWrapper } from '../clearingHouseDialogUtils'
import { allEnabledAndKnownCollateralsSelector } from 'selectors/collateralSelectors'

interface CollateralsPanelProps {
  clearingHouse: ClearingHouse
  collaterals: Collateral[]
  productSectorAggregateGetter: (productSectorId: string) => ProductSectorAggregate
  readOnly: boolean
  onUpdate: (partialClearingHouse: Partial<ClearingHouse>) => void
}

const mapStateToProps = createStructuredSelector({
  collaterals: allEnabledAndKnownCollateralsSelector,
  productSectorAggregateGetter: createProductSectorAggregateGetterSelector
})

class CollateralsPanelComponent extends React.Component<CollateralsPanelProps> {
  render() {
    const { readOnly } = this.props

    const rowData = this.buildRowData()

    return (
      <GridWrapper>
        <CollateralsPanelGrid
          rowData={rowData}
          onUpdateDirectClearing={this.handleUpdateDirectClearing}
          onUpdateSponsoredClearing={this.handleUpdateSponsoredClearing}
          disabled={readOnly}
        />
      </GridWrapper>
    )
  }

  private buildRowData(): CollateralsPanelGridRow[] {
    const { clearingHouse, collaterals, productSectorAggregateGetter } = this.props
    const directClearingLookup = new Set(clearingHouse.permittedDirectCollateralIds)
    const sponsoredClearingLookup = new Set(clearingHouse.permittedSponsoredCollateralIds)

    return collaterals.map(collateral => {
      return {
        fullProductName: ProductSectorAggregateHelper.getName(productSectorAggregateGetter(collateral.productSectorId)),
        collateral,
        directClearingEnabled: directClearingLookup.has(collateral.id),
        sponsoredClearingEnabled: sponsoredClearingLookup.has(collateral.id)
      }
    })
  }

  private handleUpdateDirectClearing = (collateralIds: string[], enabled: boolean) => {
    const { clearingHouse, onUpdate } = this.props
    onUpdate({
      permittedDirectCollateralIds: rebuildEnabledIds(clearingHouse.permittedDirectCollateralIds, collateralIds, enabled)
    })
  }

  private handleUpdateSponsoredClearing = (collateralIds: string[], enabled: boolean) => {
    const { clearingHouse, onUpdate } = this.props
    onUpdate({
      permittedSponsoredCollateralIds: rebuildEnabledIds(clearingHouse.permittedSponsoredCollateralIds, collateralIds, enabled)
    })
  }
}

export const CollateralsPanel = connect(mapStateToProps)(CollateralsPanelComponent)
